export const teamsReducerKey = "teams";
export const teamsInitialState = {
  teamId: null,
  teamState: null,
  teamCountry: null,
};
